import React, { useState } from 'react'
import ReactApexChart from 'react-apexcharts';


const TraitChart = () => {

    const [chartData, setChartData] = useState({
        series: [{
            name: 'Iterations',
            data: [200, 330, 448, 170, 122]
        }],
        options: {
            chart: {
                type: 'bar',
                width: '100%',
                toolbar: {
                    show: false,
                }
            },
            plotOptions: {
                bar: {
                    borderRadius: 10,
                    horizontal: false,
                    columnWidth: '45%'
                }
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: ['Trait1', 'Trait2', 'Trait4', 'Trait4', 'Trait4'],
            },
            colors: ['#A572FF'],
        },

    });


    return (
        <>
            <div id="chart" >
                <ReactApexChart options={chartData.options} series={chartData.series} type="bar" height='160px' />
            </div>
        </>
    )
}

export default TraitChart
